import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Breadcrumbs/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/client/Container/Container.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/client/Section/Section.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/client/Blog/BlogJsonLd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Detailed"] */ "/app/src/features/client/Blog/Detailed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/client/Blog/RatingJsonLd.tsx");
